import React, { useEffect, useRef } from 'react';
import { Star } from 'lucide-react';

const TrustpilotWidget = ({ businessUnitId = '' }) => {
  const widgetRef = useRef(null);

  useEffect(() => {
    // Load Trustpilot script
    if (businessUnitId && window.Trustpilot) {
      window.Trustpilot.loadFromElement(widgetRef.current, true);
    }
  }, [businessUnitId]);

  // If no Trustpilot business ID configured, show a placeholder with setup instructions
  if (!businessUnitId) {
    return (
      <div className="luxury-card p-6" data-testid="trustpilot-placeholder">
        <div className="flex items-center gap-2 mb-3">
          <Star className="h-5 w-5 text-[#00B67A]" />
          <h3 className="font-semibold text-[#0F172A] text-sm tracking-wider">Trustpilot Reviews</h3>
        </div>
        <div className="bg-[#F8FAFC] p-4 text-center">
          <div className="flex justify-center gap-1 mb-2">
            {[1,2,3,4,5].map(i => (
              <Star key={`star-${i}`} className="h-5 w-5 text-[#00B67A] fill-[#00B67A]" />
            ))}
          </div>
          <p className="text-sm text-slate-500 font-medium">Trusted by property professionals</p>
          <p className="text-xs text-slate-400 mt-1">Trustpilot reviews will appear here once configured.</p>
          <p className="text-[10px] text-slate-300 mt-3">Admin: Add your Trustpilot Business Unit ID in Settings to activate live reviews.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="luxury-card p-6" data-testid="trustpilot-widget">
      <div className="flex items-center gap-2 mb-3">
        <Star className="h-5 w-5 text-[#00B67A]" />
        <h3 className="font-semibold text-[#0F172A] text-sm tracking-wider">Trustpilot Reviews</h3>
      </div>
      <div
        ref={widgetRef}
        className="trustpilot-widget"
        data-locale="en-GB"
        data-template-id="56278e9abfbbba0bdcd568bc"
        data-businessunit-id={businessUnitId}
        data-style-height="52px"
        data-style-width="100%"
      >
        <a href={`https://uk.trustpilot.com/review/${businessUnitId}`} target="_blank" rel="noopener noreferrer">
          Trustpilot
        </a>
      </div>
    </div>
  );
};

export default TrustpilotWidget;
